
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Button, Grid, Typography } from "@mui/material"
import { iconos } from "../../data";
import { useStockXID } from "../../hooks";




export const DisenioBodegaYProducto = ({ children }) => {


    const { id } = useParams();
    const navigate = useNavigate();
    const { stockXIDQuery } = useStockXID(id);


    const handleGoRoute = () => {
        navigate(-1)
    }

    
    
    return (

        <Grid sx={{minHeight:'100vh', width:'100%', background:'white', p:4, mt:0.5}}>
            <Grid item xs={ 12 } sx={{ display:'flex', alignItems:'center', mb:1.5 }}>

                {(stockXIDQuery?.data) &&
                <Typography variant='h4'>{`Bodega ${stockXIDQuery?.data.bodega.nombre}`}</Typography>
                }

                <Box flex={1} />
                <Button variant="contained" color='secondary'
                    sx={{ color: '#fff', ':hover': { opacity: 0.5 }, py:1 }} onClick={ handleGoRoute }>
                    { iconos['back'] } 
                </Button>
            </Grid>

            {(stockXIDQuery?.data) &&
            <Grid container>
                <Grid item xs={ 12 } sx={{display:'flex', alignItems:'center', justifyContent:'start'}}>
                    { React.cloneElement(iconos['setting'], {style:{ color:'#8B8B8B'} })}
                    <Typography variant='h5' ml={0.5} sx={{color:'#8B8B8B'}}>
                        {`Producto ${stockXIDQuery?.data.producto.nombre} - Stock ${stockXIDQuery?.data.stock}`}
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <Box sx={{ mb:3, mt:1, height:"1.3px", background:"#8B8B8B", width:"100%" }} />
                </Grid>
            </Grid>
            }

            <Grid item xs={12} sx={{height:'82%'}}>
                { children }
            </Grid>
        </Grid>
    )

    
}
